module.exports = function() {
  return new Worker(__webpack_public_path__ + "06adddc5a54710962e47.worker.js");
};